import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function InventoryNavButReels( props ){
    console.debug("RTS Break InventoryNavButReels");

    const history = useNavigate();
    const {setCurFilter} = useSessionContext();

    function handleReelsClick(e) {
        setCurFilter(null);
        props.setOpenDrawerFx(false);
        history("/InventoryReels");
    }

    if(props.mode==="NavDrawer"){
        return (
            <>
            <ListItem button key="Reels" onClick={handleReelsClick}>
                <ListItemText primary="Reels" />
            </ListItem>
            </>
        )
    }

    return (
        <>
        <Button
            key='Reels'
            onClick={handleReelsClick}
            sx={{ my: 2, mx: 1, color: 'white', textTransform: 'unset' }}
        >
            Reels
        </Button>
        </>
    );
}



